import React, { FC } from 'react';
import FileStatus from './FileStatus';
import FileStatusesResult from './FileStatusesResult';
import * as Styled from './styles';

interface Props {
    files: { file: File; errorMessage: string; isUploading: boolean }[];
    close: () => void;
}

const FileStatuses: FC<Props> = ({ files, close }) => (
    <Styled.StatusResultWrapper>
        <Styled.FileStatusesContainer>
            {files.map(({ file, errorMessage, isUploading }) => (
                <FileStatus file={file} key={file.name} errorMessage={errorMessage} isUploading={isUploading} />
            ))}
        </Styled.FileStatusesContainer>
        <FileStatusesResult close={close} isUploadComplete={!files.some(({ isUploading }) => isUploading)} />
    </Styled.StatusResultWrapper>
);

export default FileStatuses;
